<div fxLayout>
  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <div fxLayout>
      <section *ngIf="!loading && !error" fxFlex class="section-main">
        <div fxLayout fxLayoutAlign="space-between center" style="margin-bottom: 24px">
          <div fxLayoutAlign="start center" fxLayoutGap="8px">
            <sbnb-back-button [iconOnly]="true" [routerLink]="['/direct']"></sbnb-back-button>
            <h2 class="nomargin">{{ (isMobile$ | async) ? 'Edit Widget' : 'Edit Booking Widget' }}</h2>
          </div>
          <div fxLayout fxLayoutGap="12px">
            <sbnb-button
              fxHide
              fxShow.lt-lg
              type="secondary"
              size="mini"
              label="Preview"
              (clicked)="previewWidget(this.widget.theme)"></sbnb-button>

            <sbnb-button
              *ngIf="!recentlySaved"
              type="primary"
              size="mini"
              label="Save"
              [loading]="saving"
              (clicked)="saveWidget()"></sbnb-button>

            <div *ngIf="recentlySaved" fxLayout fxLayoutAlign="center center">
              <mat-icon class="grass-darker">check</mat-icon>
              <span class="grass-darker">Saved</span>
            </div>
          </div>
        </div>

        <sbnb-helptext-wrapper
          class="helptext-wrapper-type-content"
          [area]="'content'"
          [pageId]="'direct-widget'"></sbnb-helptext-wrapper>

        <sbnb-direct-widget-edit-form
          [widget]="widget"
          [templates]="templates$ | async"
          [properties]="properties"
          (previewClicked)="previewWidget(this.widget.theme)"></sbnb-direct-widget-edit-form>

        <div style="margin-top: 36px" fxLayout fxLayoutAlign="space-between center">
          <div fxFlex fxLayout fxLayoutGap="6px" fxLayoutAlign="start center">
            <sbnb-button
              label="Delete"
              type="text"
              size="mini"
              [labelColor]="'#ED3C6A'"
              (clicked)="deleteWidgetPrompt()"></sbnb-button>
          </div>
        </div>
      </section>

      <div fxFlex="346px" fxHide.lt-lg class="preview" fxLayout="column" fxLayoutGap="16px">
        <h3>Widget Preview</h3>

        <div fxLayout="column" fxLayoutGap="6px">
          <strong>Property</strong>
          <mat-form-field>
            <mat-select [(ngModel)]="previewPropertyId">
              <mat-option *ngFor="let property of properties" [value]="property.id">{{ property.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <iframe
          *ngIf="widget && previewPropertyId"
          sandbox="allow-scripts allow-same-origin"
          style="width: 320px; height: 800px"
          frameborder="0"
          [src]="
            'https://booking.hospitable.com/widget/external/' + previewPropertyId + '?theme=' + this.widget.theme
              | safe: 'resourceUrl'
          "></iframe>
      </div>
    </div>

    <section *ngIf="loading">
      <mat-spinner diameter="24"></mat-spinner>
    </section>

    <section *ngIf="error">
      <span>
        There was an error loading this widget.
        <a [routerLink]="['/direct']">Return to Direct</a>
      </span>
    </section>
  </main>
</div>
